import {
    ILowFareResult,
    IOneWayLowFareReader,
    IRoundTripLowFareReader
} from "./low-fare-reader.interface";

export class RoundTripLowFareReader implements IRoundTripLowFareReader {
    constructor(private readonly _departureLowFareReader: IOneWayLowFareReader,
                private readonly _returnLowFareReader: IOneWayLowFareReader) {

    }

    dispose(): void {
        this._departureLowFareReader.dispose();
        this._returnLowFareReader.dispose();
    }

    getDepartureLowFare(date: Date): ILowFareResult {
        return this._departureLowFareReader.getLowFare(date);
    }
    
    getReturnLowFare(date: Date): ILowFareResult {
        return this._returnLowFareReader.getLowFare(date);
    }

    getDepartureLowFareAsync(date: Date): Promise<ILowFareResult> {
        return this._departureLowFareReader.getLowFareAsync(date);
    }
    getReturnLowFareAsync(date: Date): Promise<ILowFareResult> {
        return this._returnLowFareReader.getLowFareAsync(date);
    }
}
